import { FilterCount, FilterSection } from "@flights/search-ui";
import React from "react";
import { InputCheckbox } from "@bookingcom/bui-react";
import dealsFilterExperiment from "utils/experiments/genius/flights_ade_sr_all_deals_filter";
import useSearchFiltersController from "components/elements/SearchFilters/useSearchFiltersController";
import { t, useI18n } from "@bookingcom/lingojs-react";

export const AllDealsFilter = () => {
  const i18n = useI18n();
  const { allDeals } = useSearchFiltersController();

  if (!dealsFilterExperiment.trackWithDefaultStage()) return;

  return (
    <FilterSection
      showReset={allDeals.touched}
      attributes={{ "data-testid": "search_filter_deals_section" }}
      title={{
        text: i18n.trans(t("flights_filters_deals_title")),
        tagName: "h2",
        attributes: { id: "airlines_filter" }
      }}
      reset={{
        text: i18n.trans(t("flights_filter_reset")),
        onClick: allDeals.reset,
        attributes: { "data-testid": "search_filter_deals_reset" }
      }}
    >
      <FilterCount count={allDeals.option?.count ?? 0} attributes={{ "data-testid": "search_filter_all_deals_value" }}>
        <InputCheckbox
          label={i18n.trans(t("flights_filters_all_deals_checkbox"))}
          name="filter-deals-option"
          checked={allDeals.value}
          onChange={({ checked }) => allDeals.set(Boolean(checked))}
          attributes={{ "data-testid": "search_filter_all_deals" }}
        />
      </FilterCount>
    </FilterSection>
  );
};
